import Image from "next/image";

import PropTypes from "prop-types";

function PageBanner({ bannerText, secondText }) {
  return (
    <div className="relative h-[8.125rem] w-full lg:h-[13.75rem]">
      <Image
        src="/assets/banner/PageBanner.jpg"
        quality={40}
        priority
        alt="banner-image"
        fill
        sizes="100vw"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <h1 className="text-[1.5rem] font-bold md:text-[2.25rem]">
          {bannerText}
          <br />
        </h1>

        {secondText && (
          <p className="text-[0.875rem] font-bold">{secondText}</p>
        )}
      </div>
    </div>
  );
}

PageBanner.propTypes = {
  bannerText: PropTypes.string.isRequired,
  secondText: PropTypes.string,
};

export default PageBanner;
